import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import * as styles	 from "./our-approach-key-figure-row.module.scss"
import OurApproachKeyFigureElement from "./key-figure-v2/our-approach-key-figure-v2"
import { KeyFigureV2FieldsFragment, OurApproachKeyFigureRowFieldsFragment } from "../../../../graphql-types"

import BackArrowSvg from "../../../../static/vectors/backArrowV2.svg"
import ArrowSvg from "../../../../static/vectors/arrowV2.svg"

type OurApproachKeyFigureRowProps = { data: OurApproachKeyFigureRowFieldsFragment }

const OurApproachKeyFigureRow: React.FC<OurApproachKeyFigureRowProps> = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 825)
    }
    
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % data.keyFigures.length)
  }

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + data.keyFigures.length) % data.keyFigures.length)
  }
  
  return (
    <div className={styles.container} style={{ backgroundColor: data.backgroundColor?.hex ?? "#162B44"}}>
      <h3 className={styles.title} style={{ color: data.textColor?.hex ?? "white"}}>
        {data.title}
      </h3>
      <div className={styles.keyFiguresRow}>
        {isMobile ? (
          <div className={styles.mobileCarousel}>
            <div className={styles.keyFigure}>
              <OurApproachKeyFigureElement 
                data={data.keyFigures[currentIndex] as KeyFigureV2FieldsFragment} 
                keyFigureAmount={data.keyFigures.length} 
              />
            </div>
            {data.keyFigures.length > 1 && (
              <div className={styles.carouselButtons}>
                <button onClick={handlePrev} className={styles.prevButton}>
                  <img className={styles.arrow} src={BackArrowSvg} alt="Previous" />
                </button>
                <button onClick={handleNext} className={styles.nextButton}>
                  <img className={styles.arrow} src={ArrowSvg} alt="Next"/>
                </button>
              </div>
            )}
          </div>
        ) : (
          data.keyFigures.map((keyFigure) => (
            <div className={styles.keyFigure} key={keyFigure.id}>
              <OurApproachKeyFigureElement data={keyFigure as KeyFigureV2FieldsFragment} keyFigureAmount={data.keyFigures.length} />
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment OurApproachKeyFigureRowFields on DatoCmsOurApproachKeyFigureRow {
    __typename
    id
    title
    textColor {
        hex
    }
    backgroundColor {
        hex
    }
    keyFigures {
        ...KeyFigureV2Fields
    }
  }
`

export default OurApproachKeyFigureRow

